export const ASSETS_TYPES = {
  CRYPTO: 'crypto',
  MEME_COIN: 'memecoin',
  YOLO_ETF: 'yolo-etf',
  STOCKS: 'stock',
}
